import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Loader,
  NativeSelect,
  Paper,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { loginWithToken } from '../../api/auth';
import { setLocalStorage } from '../../storage/localStorage';

const Login = () => {
  const navigate = useNavigate();
  const [method] = useState('Token');
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    const trimmed = token.trim();
    if (!trimmed) {
      showNotification({
        message: 'Token is required',
        color: 'red',
      });
      return;
    }

    setLoading(true);
    try {
      const data = await loginWithToken(trimmed);
      setLocalStorage('authorization', {
        token: data.accessToken,
        expiresIn: data.expiresIn,
      });
      navigate('/dashboard', { replace: true });
    } catch (err: any) {
      const message =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        'Invalid token';
      showNotification({
        message,
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSignIn();
    }
  };

  return (
    <Box
      component="main"
      style={{
        minHeight: '100vh',
        background: '#f7f7f8',
        padding: '48px 24px',
      }}
    >
      <Box maw={520} mx="auto">
        <Title
          order={1}
          mb="xl"
          style={{
            fontWeight: 700,
            fontSize: 32,
            color: '#1f2328',
            letterSpacing: '-0.02em',
          }}
        >
          Sign in to vendors usage dashboard
        </Title>

        <Paper
          p="xl"
          radius="sm"
          withBorder
          shadow="sm"
          style={{
            background: '#ffffff',
            borderColor: '#d0d7de',
          }}
        >
          <Stack gap="lg">
            <Box>
              <Text fw={700} size="sm" mb={6} c="#1f2328">
                Method
              </Text>
              <NativeSelect
                value={method}
                data={['Token']}
                disabled
                styles={{
                  input: {
                    borderColor: '#d0d7de',
                    background: '#ffffff',
                  },
                }}
              />
            </Box>

            <Box>
              <Text fw={700} size="sm" mb={6} c="#1f2328">
                Token
              </Text>
              <TextInput
                value={token}
                onChange={(e) => setToken(e.currentTarget.value)}
                onKeyDown={handleKeyDown}
                styles={{
                  input: {
                    borderColor: '#d0d7de',
                  },
                }}
              />
            </Box>

            <Box>
              {loading ? (
                <Loader size="sm" />
              ) : (
                <Button
                  onClick={handleSignIn}
                  disabled={!token.trim()}
                  radius="sm"
                  style={{
                    background: '#1563ff',
                    fontWeight: 600,
                  }}
                >
                  Sign in
                </Button>
              )}
            </Box>
          </Stack>
        </Paper>
      </Box>
    </Box>
  );
};

export default Login;
